import { render, staticRenderFns } from "./accessoryManagement.vue?vue&type=template&id=0986fd5b&scoped=true&"
import script from "./accessoryManagement.vue?vue&type=script&lang=js&"
export * from "./accessoryManagement.vue?vue&type=script&lang=js&"
import style0 from "./accessoryManagement.vue?vue&type=style&index=0&id=0986fd5b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0986fd5b",
  null
  
)

export default component.exports